import script from "./freeGamme.vue?vue&type=script&setup=true&lang=js"
export * from "./freeGamme.vue?vue&type=script&setup=true&lang=js"

import "./freeGamme.vue?vue&type=style&index=0&id=836e9b2a&scoped=true&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-836e9b2a"]])

export default __exports__